export default __webpack_public_path__ + "static/media/web-logo.4f87cee0.svg";